// src/pages/HomePage.js
import React from 'react';
import HeroSection from '../components/HeroSection';
import '../App.css'; // For general styles like container

function HomePage() {
  return (
    <>
      <HeroSection />

    

    </>
  );
}

export default HomePage;